export default __webpack_public_path__ + "static/media/track-stand.59ff5ae1.jpg";